// extracted by mini-css-extract-plugin
export default {"RefImgPopover":"VersionTips_RefImgPopover__yKR0z","RefImg":"VersionTips_RefImg__fRxB0"};